import React, { Suspense } from 'react';
import { Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';

import ProgressBar from 'components/ProgressBar';
import Logout from 'components/logout';

import LoginPage from 'features/Auth/LoginPage';

import Default from 'layout/Default';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import UnauthorizedRoute from 'routes/UnauthorizedRoute';

const Dashboard = React.lazy(() => import('features/Dashboard/DashboardPage'));
const ManualKycView = React.lazy(() => import('features/Kyc/ManualKycDashboard/ManualKycView'));
const ManualKYCAdmin = React.lazy(() => import('features/Kyc/ManualKycDashboard/ManualKycAdmin'));
const SwipeShopPictureReject = React.lazy(() => import('features/Kyc/ManualKycDashboard/SwipeShopPictureReject'));
const ShopReview = React.lazy(() => import('features/ShopReview'));
const ShopReviewDetail = React.lazy(() => import('features/ShopReview/ShopReviewDetailIndex'));
const AdminConfiguration = React.lazy(() => import('features/AdminConfiguration'));

const Layout: React.FC = () => {
	return (
		<Suspense fallback={<ProgressBar loading />}>
			<Router basename={process.env.PUBLIC_URL}>
				<Default>
					<Switch>
						<AuthorizedRoute title="Logout" exact path="/logout" component={Logout} />
						<AuthorizedRoute title="Dashboard" exact path="/" component={Dashboard} />
						<AuthorizedRoute
							title="Manual Swipe KYC"
							exact
							path="/merchantkyc/manual-kyc"
							component={ManualKycView}
						/>
						<AuthorizedRoute
							title="Shop Picture Reject"
							exact
							path="/merchantkyc/shop-reject"
							component={SwipeShopPictureReject}
						/>
						<AuthorizedRoute
							title="Manual KYC Admin"
							exact
							path="/merchantkyc/manual-kyc/admin"
							component={ManualKYCAdmin}
						/>
						<AuthorizedRoute
							title="Shop Review"
							exact
							path="/merchantkyc/shop-review"
							component={ShopReview}
						/>
						<AuthorizedRoute
							title="Shop Business Review"
							exact
							path="/merchantkyc/shop-business-review"
							component={ShopReview}
						/>
						<AuthorizedRoute
							title="Shop Review Detail"
							exact
							path="/review/:category/:mid"
							component={ShopReviewDetail}
						/>
						<AuthorizedRoute
							title="Shop Business Review Detail"
							exact
							path="/review-business/:category/:mid"
							component={ShopReviewDetail}
						/>
						<AuthorizedRoute
							title="Admin Configuration"
							exact
							path="/merchantkyc/admin-config"
							component={AdminConfiguration}
						/>
						<UnauthorizedRoute exact path="/login" component={LoginPage} />
						<Redirect to="/" />
					</Switch>
				</Default>
			</Router>
		</Suspense>
	);
};

export default React.memo(Layout);
